import { useTranslation } from 'next-i18next'
import { DefaultSeo } from 'next-seo'
import { getOgImageURL } from 'services/ogimage'

/**
 * Represent the fallback SEO, should be only used in _app.js.
 */
export default function GlobalSeo() {
    const { t, i18n } = useTranslation('common')
    const ogimage = getOgImageURL('og-image-home.png', i18n.language)
    const removeFromIndexing = process.env.NEXT_PUBLIC_NO_INDEX === 'true'

    return (
        <DefaultSeo
            title={t('seoTitle')}
            description={t('seoDesc')}
            openGraph={{
                type: 'website',
                site_name: 'Todoist',
                url: process.env.NEXT_PUBLIC_BASE_URL,
                title: t('seoOpenGraphTitle'),
                locale: i18n.language,
                description: t('seoDesc'),
                images: [
                    {
                        url: ogimage,
                        width: 1200,
                        height: 628,
                        alt: t('tryTodoist'),
                    },
                ],
            }}
            twitter={{
                site: '@todoist',
                handle: '@todoist',
                cardType: 'summary_large_image',
            }}
            dangerouslySetAllPagesToNoIndex={removeFromIndexing}
            dangerouslySetAllPagesToNoFollow={removeFromIndexing}
        />
    )
}
